import React, {useEffect, useState} from 'react';
import DataTable, {TableColumn} from 'react-data-table-component';
import {confirmAlert} from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import {Button} from 'react-bootstrap';
import {toast} from 'react-toastify';
import DialogBox from '../../../components/DialogBox';
import { GrupoContableApi } from '@app/api/activosFijos/GrupoContableApi';
import GrupoContableTable from './GrupoContableTable';



interface GrupoContable {
  idgrupocontable: number;
  nombre: string;
  activo: boolean;
  cuentaactivofijo: string;
  cuentagasto: string;
  cuentadepreciacionacumulada: string;
}

const GrupoContable: React.FC = () => {
  const [data, setData] = useState<GrupoContable[]>([]);
  const [editingData, setEditingData] = useState<GrupoContable | null>(null);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [activo, setActivo] = useState<boolean>(editingData?.activo || false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleCloseGuardar = () => {
    setOpen(false);
  };

  const handleClose = () => {
    setOpen(false);
    handleReset();
  };

  const handleReset = () => {
    setEditingData(null);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await GrupoContableApi.getGrupoContable();
      setData(response.data);
      setLoading(false);
    } catch (error) {
      console.error('Error al obtener los datos:', error);
    }
  };

  const handleEdit = (row: GrupoContable) => {
    console.log('Editar:', row);
    setEditingData(row);
    handleOpen();
  };

  const handleDelete = (row: GrupoContable) => {
    console.log('Eliminar:', row);
    confirmAlert({
      title: 'Confirmar eliminación',
      message: `¿Estás seguro que deseas eliminar el registro ${row.nombre}?`,
      buttons: [
        {
          label: 'Sí',
          onClick: () => {
            const newData = data.filter(
              (d: GrupoContable) => d.idgrupocontable !== row.idgrupocontable
            );
            setData(newData);
          }
        },
        {
          label: 'No',
          onClick: () => {}
        }
      ]
    });
  };

  const handleSave = (row: GrupoContable) => {
    var validacionDatos='';
    if (row.idgrupocontable) {
      if(row.nombre.length===0)
      {
        validacionDatos = 'Nombre no puede estar en blanco';
      }
      if(row.cuentaactivofijo.length===0)
      {
        validacionDatos = 'Cuenta Activo Fijo no puede estar en blanco';
      }
      if(row.cuentagasto.length===0)
      {
        validacionDatos = 'Cuenta Gasto Fijo no puede estar en blanco';
      }
      if(row.cuentadepreciacionacumulada.length===0)
      {
        validacionDatos = 'Cuenta Depreciación no puede estar en blanco';
      }
      const actualizacion = data.find((element) => {
        if(element.nombre.toUpperCase() === row.nombre.toUpperCase() && element.idgrupocontable!==row.idgrupocontable)
        {
          validacionDatos = 'Error Nombre Duplicado, Valide el Catalogo';
          return true;
        }
      });
      if(validacionDatos.length===0)
      {
        GrupoContableApi.updateGrupoContable(row.idgrupocontable, row).then(() => {
          setData((prevGrupoContable) =>
          prevGrupoContable.map((u) => (u.idgrupocontable === row.idgrupocontable ? row : u))
          );
          toast.success('Actualización Exitosa');
          handleReset();
          handleCloseGuardar();
        })
        .catch((err) => {
          toast.error('Error de Comunicación, Contacte a TI');
        });
      }
      else{
        toast.error(validacionDatos);
      }
    } else {
      if(row.nombre.length===0)
      {
        validacionDatos = 'Nombre no puede estar en blanco';
      }
      if(row.cuentaactivofijo.length===0)
      {
        validacionDatos = 'Cuenta Activo Fijo no puede estar en blanco';
      }
      if(row.cuentagasto.length===0)
      {
        validacionDatos = 'Cuenta Gasto Fijo no puede estar en blanco';
      }
      if(row.cuentadepreciacionacumulada.length===0)
      {
        validacionDatos = 'Cuenta Depreciación no puede estar en blanco';
      }
      const creacion = data.find((element) => {
        if(element.nombre.toUpperCase() === row.nombre.toUpperCase())
        {
          validacionDatos = 'Error Nombre Duplicado, Valide el Catalogo';
          return true;
        }
      });
      if(validacionDatos.length===0)
      {
        GrupoContableApi.createGrupoContable(row).then((response) => {
          setData((prevGrupoContable) => [...prevGrupoContable, response.data]);
          toast.success('Creación Exitosa');
          handleReset();
          handleCloseGuardar();
        })
        .catch((err) => {
          toast.error('Error de Comunicación, Contacte a TI');
        });
      }
      else{
        toast.error(validacionDatos);
      } 
    }
  };

  const columns: TableColumn<GrupoContable>[] = [
    {name: 'Grupo contable', selector: (row) => row.nombre},
    {name: 'Cuenta activo fijo', selector: (row) => row.cuentaactivofijo},
    {name: 'Cuenta gasto', selector: (row) => row.cuentagasto},
    {name: 'Cuenta de preciación acumulada', selector: (row) => row.cuentadepreciacionacumulada},
    {
      name: 'Acciones',
      cell: (row: GrupoContable) => (
        <div>
          <button
            onClick={() => handleEdit(row)}
            className="btn btn-primary btn-sm"
          >
            <i className="fa fa-pen"></i> Editar{' '}
          </button>
          &nbsp;
          <button
            onClick={() => handleDelete(row)}
            className="btn btn-danger btn-sm"
          >
            <i className="fa fa-eraser"></i> Eliminar{' '}
          </button>
        </div>
      )
    }
  ];

  return (
    <div>
      <Button variant="success" onClick={handleOpen}>
        <i className="fa fa-plus"></i> Agregar{' '}
      </Button>
      {loading ? (
        <p>Cargando...</p>
      ) : (
        <GrupoContableTable
          data={data}
          columns={columns}
          customStyles={customStyles}
        />
      )}
      <DialogBox
        open={open}
        onClose={handleClose}
        title={editingData ? 'Editar' : 'Agregar'}
        content={
          <form
            onSubmit={(event) => {
              event.preventDefault();
              const formData = new FormData(event.currentTarget);
              const row: GrupoContable = {
                idgrupocontable: editingData?.idgrupocontable || 0,
                nombre: formData.get('nombre') as string,
                cuentaactivofijo: formData.get('cuentaactivofijo') as string,
                cuentagasto: formData.get('cuentagasto') as string,
                cuentadepreciacionacumulada: formData.get('cuentadepreciacionacumulada') as string,
                activo
              };
              handleSave(row);
            }}
          >
           <div className="form-group" id="nombre">
              <div className="input-group mb-3">
                <div className="input-group-prepend">
                  <span className="input-group-text">Grupo Contable</span>
                </div>
                <input
                  type="text"
                  name="nombre"
                  className="form-control "
                  defaultValue={editingData?.nombre}
                  placeholder="Ingrese el Grupo Contable"
                />
              </div>
            </div>
            <div className="form-group" id="cuentaactivofijo">
              <div className="input-group mb-3">
                <div className="input-group-prepend">
                  <span className="input-group-text">Cuenta Activo Fijo</span>
                </div>
                <input
                  type="text"
                  name="cuentaactivofijo"
                  className="form-control "
                  defaultValue={editingData?.cuentaactivofijo}
                  placeholder="Ingrese la Cuenta Activo Fijo"
                />
              </div>
            </div>
            <div className="form-group" id="cuentagasto">
              <div className="input-group mb-3">
                <div className="input-group-prepend">
                  <span className="input-group-text">Cuenta Gasto</span>
                </div>
                <input
                  type="text"
                  name="cuentagasto"
                  className="form-control "
                  defaultValue={editingData?.cuentagasto}
                  placeholder="Ingrese la Cuenta Gasto"
                />
              </div>
            </div>
            <div className="form-group" id="cuentadepreciacionacumulada">
              <div className="input-group mb-3">
                <div className="input-group-prepend">
                  <span className="input-group-text">Cuenta Depreciación Acumulada</span>
                </div>
                <input
                  type="text"
                  name="cuentadepreciacionacumulada"
                  className="form-control "
                  defaultValue={editingData?.cuentadepreciacionacumulada}
                  placeholder="Ingrese la Cuenta Depreciación Acumulada"
                />
              </div>
            </div>
            <div className="form-group custom-control custom-checkbox">
              <input
                className="custom-control-input"
                type="checkbox"
                checked={activo}
                onChange={(e) => setActivo(e.target.checked)}
                defaultChecked={editingData?.activo}
                id="activo"
              />
              <label htmlFor="activo" className="custom-control-label">
                Activo
              </label>
            </div>

            <div className="modal-footer justify-content-between">
              <Button
                type="button"
                className="btn btn-danger"
                onClick={handleClose}
              >
                Cerrar
              </Button>
              <Button type="submit" className="btn btn-success">
                {editingData ? 'Guardar' : 'Agregar'}
              </Button>
            </div>
          </form>
        }
      />
    </div>
  );
};

const customStyles = {
  headCells: {
    style: {
      fontSize: '18px',
      fontWeight: 'bold',
      fontFamily: 'Arial'
    }
  },
  rows: {
    style: {
      fontSize: '18px'
    }
  },
  cells: {
    style: {
      fontSize: '16px'
    }
  },
  pagination: {
    style: {
      fontSize: '14px'
    }
  }
};

export default GrupoContable;